import React from "react";

import lbl from "../../data/Labels.json";

const FinanceSummaryCard = ({ title, data: { summary } }) => {
  return (
    <div className="summary-card">
      <div className="summary-title">{title}</div>
      <ul>
        <li>
          <b>{summary?.opening_balance || 0}</b>
          <span>{lbl.OpeningBalance}</span>
        </li>
        <li>
          <b>{summary?.total_payable || 0}</b>
          <span>{lbl.Payable}</span>
        </li>

        <li>
          <b>{summary?.total_paid || 0}</b>
          <span>{lbl.Paid}</span>
        </li>

        <li>
          <b>{summary?.overall_balance || 0}</b>
          <span>{lbl.OverallBalance}</span>
        </li>
      </ul>
    </div>
  );
};

export default FinanceSummaryCard;
